// sessionManager.js
import { getTokenExpiration, logout } from "./../Auth/authService";

let logoutTimer = null;

export const setupAutoLogout = () => {
  clearAutoLogout();

  const expMs = getTokenExpiration();
  if (!expMs) return;

  const timeout = expMs - Date.now();
  if (timeout <= 0) {
    logout();
    return;
  }

  logoutTimer = setTimeout(() => {
    logout();
  }, timeout);

  console.log("⏱ Auto logout scheduled in", Math.round(timeout / 1000), "seconds");
};

export const clearAutoLogout = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
};
